import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import PropTypes from "prop-types";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import ComponentToPrint from "./component_to_print";

const styles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2)
    },
    dialogPaper: {
        minHeight: '90vh',
        maxHeight: '90vh',
        minWidth: '90vw',
        maxWidth: '90vw'
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500]
    }
});

const ModalPreview = withStyles(styles)(props => {
    const { classes } = props;
    return (
        <div>
            <Dialog
                classes={{ paper: classes.dialogPaper }}
                fullWidth
                open={props.open}
                onClose={props.handleClose}
                maxWidth={'xl'}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <div>
                        <IconButton aria-label="close" className={classes.closeButton} onClick={props.handleClose}>
                            <CloseIcon />
                        </IconButton>
                        <ComponentToPrint
                            content={props.content}
                            ref={props.previewRef} />
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
});

ModalPreview.propTypes = {
    handleClose: PropTypes.func.isRequired,
    content: PropTypes.string,
    previewRef: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired
};

export default ModalPreview;
